import { Breadcrumb, Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import { Link, useLocation } from "react-router-dom";
import { Element, Link as LinkSection } from "react-scroll";
import { BigPlayButton, Player } from "video-react";

import CardDetail from "components/CardDetail";
import DetailContact from "components/DetailContact";
import FadeInSection from "components/FadeInSection";
import ListImage from "components/ListImage";
import LoadingSpin from "components/Loading";
import NumberImage from "components/NumberImage";
import ScrollUpBtn from "components/ScrollUpBtn";
import TableGPAX from "components/TableGPAX";
import ViewSelect from "components/ViewSelect";
import YearSelect from "components/YearSelect";

import { contract, institute } from "core/schemas";
import {
  breadcrumbName,
  ListColor1,
  ListColor2,
  ListColorContact,
  ListContact,
  ListView,
  WebsiteEngi,
} from "core/util/common";
import { httpClient } from "core/util/httpClient";

import {
  BlockName,
  Box,
  CardContact,
  Container,
  CustomCarousel,
  CusttomBreadcrumb,
  Detail,
  DetailBottom,
  DetailTop,
  FixBox,
  FixBoxLayout,
  HoverAni,
  Href,
  Line,
  NameCourse,
  NumberList,
  SubDetail,
  SubHead,
  SubTitle,
  TextHead,
  TextName,
  TextNote,
  Title,
  TitleEN,
  TitleSelect,
  View,
} from "./engineering.style";

import stuView from "assets/images/png/student_comp-01.png";

import downloadIcon from "assets/images/svg/icon-file-download.svg";

import learnIcon1 from "assets/images/svg/H09-1.svg";
import learnIcon2 from "assets/images/svg/H09-2.svg";

import titleSci1 from "assets/images/svg/title-sci-1.svg";
import titleSci2 from "assets/images/svg/title-sci-2.svg";
import titleSci3 from "assets/images/svg/title-sci-3.svg";

import titleSoct1 from "assets/images/svg/title-soct-1.svg";
import titleSoct2 from "assets/images/svg/title-soct-2.svg";
import titleSoct3 from "assets/images/svg/title-soct-3.svg";

import titleAgri1 from "assets/images/svg/title-agri-1.svg";
import titleAgri2 from "assets/images/svg/title-agri-2.svg";
import titleAgri3 from "assets/images/svg/title-agri-3.svg";

import titlePubh1 from "assets/images/svg/title-pubh-1.svg";
import titlePubh2 from "assets/images/svg/title-pubh-2.svg";
import titlePubh3 from "assets/images/svg/title-pubh-3.svg";

import titleMed1 from "assets/images/svg/title-med-1.svg";
import titleMed2 from "assets/images/svg/title-med-2.svg";
import titleMed3 from "assets/images/svg/title-med-3.svg";

import titleNurs1 from "assets/images/svg/title-nurs-1.svg";
import titleNurs2 from "assets/images/svg/title-nurs-2.svg";
import titleNurs3 from "assets/images/svg/title-nurs-3.svg";

import titleDigi1 from "assets/images/svg/title-digi-1.svg";
import titleDigi2 from "assets/images/svg/title-digi-2.svg";
import titleDigi3 from "assets/images/svg/title-digi-3.svg";

import titleEngi1 from "assets/images/svg/title-engi-1.svg";
import titleEngi2 from "assets/images/svg/title-engi-2.svg";
import titleEngi3 from "assets/images/svg/title-engi-3.svg";

import titleDent1 from "assets/images/svg/title-dent-1.svg";
import titleDent2 from "assets/images/svg/title-dent-2.svg";
import titleDent3 from "assets/images/svg/title-dent-3.svg";

import sci from "assets/images/png/01-Sci.png";
import soctech from "assets/images/png/02-Soctech.png";
import agri from "assets/images/png/03-Agri.png";
import engi from "assets/images/png/04-Engi.png";
import med from "assets/images/png/05-Med.png";
import nurs from "assets/images/png/06-Nurs.png";
import dent from "assets/images/png/07-Dent.png";
import pubH from "assets/images/png/08-PubH.png";
import digiT from "assets/images/png/09-DigiT.png";

import engGPAX from "assets/images/png/04-11-illus.png";
import handRightIcon from "assets/images/svg/icon-awesome-hand-point-right.svg";

function EngineeringDepartment({ selectYear, year }) {
  const { pathname } = useLocation();
  const splitPath = pathname.split("/") || [];
  splitPath.shift();

  const [gradeData, setGradeData] = useState([]);
  const [departmentData, setDepartmentData] = useState({});
  const [contactData, setContactData] = useState([]);
  const [slang, setSlang] = useState("");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const styleDetailContact = { marginBottom: "5px" };
  const [isLoading, setIsLoading] = useState(false);
  const [view, setView] = useState({
    viewAll: 0,
    viewOfYear: 0,
  });

  useEffect(() => {
    window.scrollTo(0, 0);

    getDataEnrollment();
    getCalGrade();
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
  }, []);

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  const getCalGrade = async () => {
    const response = await httpClient.get(`page/table_gpa?group=499`);

    if (response?.data?.code === 200) {
      const data = response?.data?.data;

      setGradeData(data);
    } else {
      setGradeData([]);
    }
  };

  const getView = async (year) => {
    const response = await httpClient.get(
      `${institute}?course=${splitPath[1]}&year=${year}`
    );

    if (response?.data?.code === 200) {
      const data = response?.data?.data;
      setView({
        viewAll: data?.visitor,
        viewOfYear: data?.visitor_of_year,
      });
    } else {
      setView({ viewOfYear: 0, viewAll: 0 });
    }
  };

  const getDataEnrollment = async () => {
    setIsLoading(false);
    const response = await httpClient.get(
      `${institute}?course=${splitPath[1]}&year=2024`,
      { incrementVisitor: true }
    );

    if (response?.data?.code === 200) {
      const data = response?.data?.data;
      setIsLoading(true);
      setDepartmentData(data);
      setSlang(data?.slang);
      getDataContact(data?.id);
      setView({
        viewAll: data?.visitor,
        viewOfYear: data?.visitor_of_year,
      });
    } else {
      setIsLoading(true);
      setDepartmentData([]);
      setView({ viewOfYear: 0, viewAll: 0 });
    }
  };

  const getDataContact = async (id) => {
    const response = await httpClient.get(
      `${contract}?course=${id && id}&year=2024`
    );

    if (response?.data?.code === 200) {
      const data = response?.data?.data;

      setContactData(data);
    } else {
      setContactData([]);
    }
  };

  const newPath = (route) => {
    let path = "";
    const orderRoute = splitPath.indexOf(route);
    splitPath.map((item, i) => i <= orderRoute && (path += `/${item}`));
    return path;
  };

  const splitName = (text, position, detail) => {
    const word = text.split("\n");

    return <>{word[position]}</>;
  };

  const spliteLink = (link, text) => {
    const newLink = link.split(text);
    return (
      <div className="link-web">
        {text}
        <a href={`https://${newLink[1]}`} target="_blank" rel="noreferrer">
          <u>{newLink[1]}</u>
        </a>
      </div>
    );
  };

  const spliteLinkEng = (link, text) => {
    const newLink = link.split(text);
    return (
      <div className="link-web eng">
        {newLink[0]}
        <a href={newLink[1]} target="_blank" rel="noreferrer">
          <u>{text}</u>
        </a>
      </div>
    );
  };

  const spliteLinkProject = (data, text, link) => {
    const newLink = data.split(text);
    return (
      <div className="link-web bold">
        <span>Download</span>
        <a href={link} target="_blank" rel="noreferrer" download>
          <u>{newLink[1]}</u>
        </a>
      </div>
    );
  };

  const renderLink = (to, name) => {
    return (
      <LinkSection
        activeClass="active"
        to={to}
        spy={true}
        smooth={true}
        duration={500}
        offset={-130}
      >
        <HoverAni>
          <NameCourse height="105">{name}</NameCourse>
        </HoverAni>
      </LinkSection>
    );
  };

  const listImage1 = {
    "department-science": titleSci1,
    "department-social": titleSoct1,
    "department-agricultural": titleAgri1,
    "department-engineering": titleEngi1,
    "department-medicine": titleMed1,
    "department-nursing": titleNurs1,
    "department-dentistry": titleDent1,
    "department-public-health": titlePubh1,
    "department-degitech": titleDigi1,
  };

  const listImage2 = {
    "department-science": titleSci2,
    "department-social": titleSoct2,
    "department-agricultural": titleAgri2,
    "department-engineering": titleEngi2,
    "department-medicine": titleMed2,
    "department-nursing": titleNurs2,
    "department-dentistry": titleDent2,
    "department-public-health": titlePubh2,
    "department-degitech": titleDigi2,
  };

  const listImage3 = {
    "department-science": titleSci3,
    "department-social": titleSoct3,
    "department-agricultural": titleAgri3,
    "department-engineering": titleEngi3,
    "department-medicine": titleMed3,
    "department-nursing": titleNurs3,
    "department-dentistry": titleDent3,
    "department-public-health": titlePubh3,
    "department-degitech": titleDigi3,
  };

  const listImageContact = {
    "department-science": sci,
    "department-social": soctech,
    "department-agricultural": agri,
    "department-engineering": engi,
    "department-medicine": med,
    "department-nursing": nurs,
    "department-dentistry": dent,
    "department-public-health": pubH,
    "department-degitech": digiT,
  };

  const styleImage = {
    maxWidth: "100%",
    margin: "20px 0",
  };

  return (
    <>
      <Container>
        <div className={`year-box ${slang}`}>
          <p>ข้อมูลประจำปี</p>
          <YearSelect onChange={selectYear && selectYear} year={year} minBeYear={2567} />
        </div>
        {isLoading ? (
          <>
            <Row>
              <Col span={24}>
                <CusttomBreadcrumb>
                  {splitPath.map((item, i) => {
                    if (i !== splitPath.length - 1 && i !== 0) {
                      return (
                        <Breadcrumb.Item key={item}>
                          <Link to={newPath(item)}>{breadcrumbName[item]}</Link>
                        </Breadcrumb.Item>
                      );
                    } else {
                      return (
                        <Breadcrumb.Item key={item}>
                          <Link to={newPath(item)}>
                            {" "}
                            {breadcrumbName[item]}
                          </Link>
                        </Breadcrumb.Item>
                      );
                    }
                  })}
                </CusttomBreadcrumb>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Title className="animate__animated animate__slideInDown animate__slow">
                  {departmentData?.nameTH}
                </Title>
                <TitleEN className="animate__animated animate__flipInX animate__slow">
                  {departmentData?.nameEN}
                </TitleEN>
              </Col>
            </Row>

            {windowWidth <= 1280
              ? departmentData?.message && (
                  <Row className="row-title">
                    <Col span={12}>
                      <BlockName row={3}>
                        <img
                          loading="lazy"
                          src={listImage1[slang]}
                          alt="icon title"
                          style={{ maxWidth: "104px", width: "100%" }}
                        />

                        <TextName>
                          {splitName(departmentData?.message?.title, 0)}
                          <span>
                            {splitName(departmentData?.message?.title, 1, true)}
                          </span>
                        </TextName>
                      </BlockName>

                      <div className="col-image-profile">
                        <FadeInSection axis="y">
                          <img
                            loading="lazy"
                            src={
                              departmentData?.message?.image &&
                              departmentData?.message?.image[0]?.image_0
                            }
                            alt="dean"
                            style={{ marginTop: "20px", width: "100%" }}
                          />
                        </FadeInSection>
                      </div>

                      {departmentData?.message?.text &&
                        departmentData?.message?.text.map((item) => {
                          return (
                            <>
                              {item?.text_0 && (
                                <DetailTop>{item?.text_0}</DetailTop>
                              )}
                              {item?.text_1 && (
                                <DetailBottom>{item?.text_1}</DetailBottom>
                              )}
                              {item?.text_2 && (
                                <DetailBottom>{item?.text_2}</DetailBottom>
                              )}
                              {item?.text_3 && (
                                <DetailBottom>{item?.text_3}</DetailBottom>
                              )}
                            </>
                          );
                        })}
                    </Col>

                    {departmentData?.message?.image &&
                      departmentData?.message?.image.map((item) => {
                        return (
                          <>
                            <Col
                              span={11}
                              offset={1}
                              style={{
                                display: "flex",
                                alignItems: "baseline",
                              }}
                              className="col-image-profile"
                            ></Col>
                            {item?.image_1 && item?.image_2 && (
                              <Player
                                poster={item?.image_1}
                                className="img-people"
                                autoPlay
                                muted
                                playsInline
                                src={item?.image_2}
                              >
                                <BigPlayButton position="center" />
                              </Player>
                            )}
                          </>
                        );
                      })}
                  </Row>
                )
              : departmentData?.message && (
                  <Row className="row-title">
                    <Col span={12}>
                      <BlockName row={3}>
                        <img
                          loading="lazy"
                          src={listImage1[slang]}
                          alt="icon title"
                          style={{ width: "104px" }}
                        />

                        <TextName>
                          {splitName(departmentData?.message?.title, 0)}
                          <span>
                            {splitName(departmentData?.message?.title, 1, true)}
                          </span>
                        </TextName>
                      </BlockName>

                      {departmentData?.message?.text &&
                        departmentData?.message?.text.map((item) => {
                          return (
                            <>
                              {item?.text_0 && (
                                <DetailTop>{item?.text_0}</DetailTop>
                              )}
                              {item?.text_1 && (
                                <DetailBottom>{item?.text_1}</DetailBottom>
                              )}
                              {item?.text_2 && (
                                <DetailBottom>{item?.text_2}</DetailBottom>
                              )}
                              {item?.text_3 && (
                                <DetailBottom>{item?.text_3}</DetailBottom>
                              )}
                            </>
                          );
                        })}
                    </Col>

                    {departmentData?.message?.image &&
                      departmentData?.message?.image.map((item) => {
                        return (
                          <>
                            <Col
                              span={11}
                              offset={1}
                              style={{
                                display: "flex",
                                alignItems: "baseline",
                              }}
                              className="col-image-profile"
                            >
                              <FadeInSection axis="y">
                                <img
                                  loading="lazy"
                                  src={item?.image_0}
                                  alt="dean"
                                  width={"100%"}
                                />
                              </FadeInSection>
                            </Col>
                            {item?.image_1 && item?.image_2 && (
                              <Player
                                poster={item?.image_1}
                                className="img-people"
                                autoPlay
                                muted
                                playsInline
                                src={item?.image_2}
                              >
                                <BigPlayButton position="center" />
                              </Player>
                            )}
                          </>
                        );
                      })}
                  </Row>
                )}

            {departmentData?.contract && (
              <Row>
                <Col span={24}>
                  <BlockName row={2}>
                    <img
                      loading="lazy"
                      src={listImage2[slang]}
                      alt="icon title"
                      style={{ width: "104px" }}
                    />
                    <TextName>
                      {departmentData?.contract[0]?.department}
                    </TextName>
                  </BlockName>

                  <Row className="row-name-course top" gutter={[24, 6]}>
                    {departmentData?.contract.slice(1).map((item, index) => {
                      return (
                        <Col span={8} key={index}>
                          <Href
                            to={WebsiteEngi[item?.department]}
                            rel="noopener noreferrer"
                            target={"_blank"}
                          >
                            <NameCourse>{item?.department}</NameCourse>
                          </Href>
                        </Col>
                      );
                    })}
                  </Row>
                </Col>
              </Row>
            )}

            {departmentData?.advice && (
              <Row>
                <Col span={24}>
                  <BlockName row={3}>
                    <img
                      loading="lazy"
                      src={listImage3[slang]}
                      alt="icon title"
                      style={{ width: "104px" }}
                    />
                    <TextName>{departmentData?.advice?.title}</TextName>
                  </BlockName>

                  <Row className="row-question" gutter={[24, 6]}>
                    {departmentData?.advice?.text &&
                      departmentData?.advice?.text.map((item) => {
                        return (
                          <>
                            {item?.text_0 ===
                              "à¹€à¸£à¸µà¸¢à¸™ à¸¡à¸—à¸ª. à¸­à¸¢à¹ˆà¸²à¸‡à¹„à¸£à¹ƒà¸«à¹‰à¸ˆà¸šà¸•à¸²à¸¡à¹€à¸§à¸¥à¸² ?" ||
                            item?.text_0 ===
                              "à¹€à¸£à¸µà¸¢à¸™à¸žà¸¢à¸²à¸šà¸²à¸¥ à¸¡à¸—à¸ª. à¸­à¸¢à¹ˆà¸²à¸‡à¹„à¸£à¹ƒà¸«à¹‰à¸ˆà¸šà¸•à¸²à¸¡à¹€à¸§à¸¥à¸² ?" ? (
                              <Col span={8}>
                                {renderLink(
                                  "à¹€à¸£à¸µà¸¢à¸™à¸­à¸¢à¹ˆà¸²à¸‡à¹„à¸£à¹ƒà¸«à¹‰à¸ˆà¸šà¸•à¸²à¸¡à¹€à¸§à¸¥à¸² ?",
                                  item?.text_0
                                )}
                              </Col>
                            ) : (
                              <Col span={8}>
                                {renderLink(item?.text_0, item?.text_0)}
                              </Col>
                            )}

                            {item?.text_1 ===
                              "à¹€à¸£à¸µà¸¢à¸™ à¸¡à¸—à¸ª. à¸­à¸¢à¹ˆà¸²à¸‡à¹„à¸£à¹ƒà¸«à¹‰à¸ˆà¸šà¸•à¸²à¸¡à¹€à¸§à¸¥à¸² ?" ||
                            item?.text_1 ===
                              "à¹€à¸£à¸µà¸¢à¸™à¹à¸žà¸—à¸¢à¹Œà¸­à¸¢à¹ˆà¸²à¸‡à¹„à¸£à¹ƒà¸«à¹‰à¸ˆà¸šà¸•à¸²à¸¡à¹€à¸§à¸¥à¸² ?" ? (
                              <Col span={8}>
                                {renderLink(
                                  "à¹€à¸£à¸µà¸¢à¸™à¸­à¸¢à¹ˆà¸²à¸‡à¹„à¸£à¹ƒà¸«à¹‰à¸ˆà¸šà¸•à¸²à¸¡à¹€à¸§à¸¥à¸² ?",
                                  item?.text_1
                                )}
                              </Col>
                            ) : (
                              <Col span={8}>
                                {renderLink(item?.text_1, item?.text_1)}
                              </Col>
                            )}

                            {item?.text_2 && (
                              <Col span={8}>
                                {renderLink(item?.text_2, item?.text_2)}
                              </Col>
                            )}

                            {item?.text_3 && (
                              <Col span={8}>
                                {renderLink(item?.text_3, item?.text_3)}
                              </Col>
                            )}
                            {item?.text_4 && (
                              <Col span={8}>
                                {renderLink(item?.text_4, item?.text_4)}
                              </Col>
                            )}
                            {item?.text_5 && (
                              <Col span={8}>
                                {renderLink(item?.text_5, item?.text_5)}
                              </Col>
                            )}
                            {item?.text_6 && (
                              <Col span={8}>
                                {renderLink(item?.text_6, item?.text_6)}
                              </Col>
                            )}
                            {item?.text_7 && (
                              <Col span={8}>
                                {renderLink(item?.text_7, item?.text_7)}
                              </Col>
                            )}
                            {item?.text_8 && (
                              <Col span={8}>
                                {renderLink(item?.text_8, item?.text_8)}
                              </Col>
                            )}
                            {item?.text_9 && (
                              <Col span={8}>
                                {renderLink(item?.text_9, item?.text_9)}
                              </Col>
                            )}
                            {item?.text_10 && (
                              <Col span={8}>
                                {renderLink(item?.text_10, item?.text_10)}
                              </Col>
                            )}
                            {item?.text_11 && (
                              <Col span={8}>
                                {renderLink(item?.text_11, item?.text_11)}
                              </Col>
                            )}
                            {item?.text_12 && (
                              <Col span={8}>
                                {renderLink(item?.text_12, item?.text_12)}
                              </Col>
                            )}
                            {item?.text_13 && (
                              <Col span={8}>
                                {renderLink(item?.text_13, item?.text_13)}
                              </Col>
                            )}
                            {item?.text_14 && (
                              <Col span={8}>
                                {renderLink(item?.text_14, item?.text_14)}
                              </Col>
                            )}
                            {item?.text_15 && (
                              <Col span={8}>
                                {renderLink(item?.text_15, item?.text_15)}
                              </Col>
                            )}
                            {item?.text_16 && (
                              <Col span={8}>
                                {renderLink(item?.text_16, item?.text_16)}
                              </Col>
                            )}
                            {item?.text_17 && (
                              <Col span={8}>
                                {renderLink(item?.text_17, item?.text_17)}
                              </Col>
                            )}
                            {item?.text_18 && (
                              <Col span={8}>
                                {renderLink(item?.text_18, item?.text_18)}
                              </Col>
                            )}
                            {item?.text_19 && (
                              <Col span={8}>
                                {renderLink(item?.text_19, item?.text_19)}
                              </Col>
                            )}
                            {item?.text_20 && (
                              <Col span={8}>
                                {renderLink(item?.text_20, item?.text_20)}
                              </Col>
                            )}
                          </>
                        );
                      })}
                  </Row>
                </Col>
              </Row>
            )}

            {departmentData?.misstion && (
              <Element name={departmentData?.misstion?.title}>
                <FixBox bg={ListColor2[slang]}>
                  <SubTitle top="50">
                    {departmentData?.misstion?.title}
                  </SubTitle>
                  <Row gutter={24} className="row-detail-card">
                    {departmentData?.misstion?.data.map((item, index) => {
                      return (
                        index < 3 && (
                          <>
                            <Col span={8} key={index}>
                              <FadeInSection axis="x">
                                <img
                                  loading="lazy"
                                  src={item?.image ? item?.image : engineer}
                                  alt="misstion"
                                  style={{
                                    width: "100%",
                                    borderRadius: "20px",
                                    marginBottom: "20px",
                                  }}
                                />
                              </FadeInSection>
                              <SubHead font="Noto Sans Thai Bold">
                                {item?.title}
                              </SubHead>

                              {item?.text_0 && (
                                <SubDetail
                                  top="0"
                                  bottom={
                                    index === 0 &&
                                    departmentData?.misstion?.data[3]
                                      ? "35"
                                      : "0"
                                  }
                                  color={
                                    item?.title === "à¸„à¹ˆà¸²à¸™à¸´à¸¢à¸¡ â€œWELLâ€"
                                      ? "#81000F"
                                      : "var(--black)"
                                  }
                                >
                                  {item?.text_0}
                                </SubDetail>
                              )}
                              {index === 0 &&
                                departmentData?.misstion?.data[3] && (
                                  <>
                                    <SubHead font="Noto Sans Thai Bold">
                                      {departmentData?.misstion?.data[3]?.title}
                                    </SubHead>
                                    {departmentData?.misstion?.data[3]
                                      ?.text_0 && (
                                      <SubDetail
                                        top="0"
                                        bottom="0"
                                        color="var(--black)"
                                      >
                                        {
                                          departmentData?.misstion?.data[3]
                                            ?.text_0
                                        }
                                      </SubDetail>
                                    )}
                                  </>
                                )}
                              {item?.text_1 && (
                                <SubDetail top="0" bottom="0">
                                  {item?.text_1}
                                </SubDetail>
                              )}
                              {item?.text_2 && (
                                <SubDetail
                                  top="0"
                                  bottom="0"
                                  color={
                                    item?.title === "à¸„à¹ˆà¸²à¸™à¸´à¸¢à¸¡ â€œWELLâ€"
                                      ? "#81000F"
                                      : "var(--black)"
                                  }
                                >
                                  {item?.text_2}
                                </SubDetail>
                              )}
                              {item?.text_3 && (
                                <SubDetail top="0" bottom="0">
                                  {item?.text_3}
                                </SubDetail>
                              )}
                              {item?.text_4 && (
                                <SubDetail
                                  top="0"
                                  bottom="0"
                                  color={
                                    item?.title === "à¸„à¹ˆà¸²à¸™à¸´à¸¢à¸¡ â€œWELLâ€"
                                      ? "#81000F"
                                      : "var(--black)"
                                  }
                                >
                                  {item?.text_4}
                                </SubDetail>
                              )}
                              {item?.text_5 && (
                                <SubDetail top="0" bottom="0">
                                  {item?.text_5}
                                </SubDetail>
                              )}
                              {item?.text_6 && (
                                <SubDetail
                                  top="0"
                                  bottom="0"
                                  color={
                                    item?.title === "à¸„à¹ˆà¸²à¸™à¸´à¸¢à¸¡ â€œWELLâ€"
                                      ? "#81000F"
                                      : "var(--black)"
                                  }
                                >
                                  {item?.text_6}
                                </SubDetail>
                              )}
                              {item?.text_7 && (
                                <SubDetail top="0" bottom="0">
                                  {item?.text_7}
                                </SubDetail>
                              )}
                            </Col>
                          </>
                        )
                      );
                    })}
                  </Row>
                </FixBox>
              </Element>
            )}

            {departmentData?.study && (
              <Element name={departmentData?.study?.title}>
                <SubTitle top="0">{departmentData?.study?.title}</SubTitle>
                {departmentData?.study?.sub_title && (
                  <SubDetail indent="32">
                    {departmentData?.study?.sub_title}
                  </SubDetail>
                )}
                <Row gutter={24} className="row-detail-card">
                  {departmentData?.study?.data.map((item, index) => {
                    return (
                      <Col span={8} key={index}>
                        <CardDetail src={item?.image} detail={item?.detail} />
                      </Col>
                    );
                  })}
                </Row>
              </Element>
            )}

            {departmentData?.result && (
              <Element name={departmentData?.result?.title}>
                <FixBox bg={ListColor2[slang]}>
                  <Row gutter={24} className="row-group">
                    <Col span={11}>
                      <FadeInSection axis="x">
                        <CustomCarousel autoplay bg={ListColor1[slang]}>
                          {departmentData?.result?.image &&
                            departmentData?.result?.image[0]?.image_0 && (
                              <img
                                loading="lazy"
                                src={departmentData?.result?.image[0]?.image_0}
                                alt="icon group"
                                style={{
                                  borderRadius: "20px",
                                  width: "100%",
                                }}
                              />
                            )}
                          {departmentData?.result?.image &&
                            departmentData?.result?.image[0]?.image_1 && (
                              <img
                                loading="lazy"
                                src={departmentData?.result?.image[0]?.image_1}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                          {departmentData?.result?.image &&
                            departmentData?.result?.image[0]?.image_2 && (
                              <img
                                loading="lazy"
                                src={departmentData?.result?.image[0]?.image_2}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            )}
                        </CustomCarousel>
                      </FadeInSection>
                    </Col>
                    <Col span={12} offset={1}>
                      <SubTitle>{departmentData?.result?.title}</SubTitle>

                      <SubDetail className="bg-circle" bottom="0">
                        <img
                          loading="lazy"
                          src={learnIcon1}
                          alt="icon circle"
                        />
                        {departmentData?.result?.text[0]?.text_0}
                      </SubDetail>

                      {(departmentData?.result?.text[0]?.text_1 ||
                        departmentData?.result?.text[0]?.text_2) && (
                        <SubDetail indent="32" bottom="0" top="0">
                          {departmentData?.result?.text[0]?.text_1 &&
                            departmentData?.result?.text[0]?.text_1}
                          {departmentData?.result?.text[0]?.text_2 &&
                            departmentData?.result?.text[0]?.text_2}
                        </SubDetail>
                      )}

                      {departmentData?.result?.text[0]?.text_3 && (
                        <SubDetail indent="32" bottom="0" top="0">
                          {departmentData?.result?.text[0]?.text_3}
                        </SubDetail>
                      )}

                      {departmentData?.result?.text[0]?.text_4 && (
                        <SubDetail indent="32" bottom="0" top="0">
                          {departmentData?.result?.text[0]?.text_4}
                        </SubDetail>
                      )}

                      {departmentData?.result?.text[0]?.text_5 && (
                        <SubDetail indent="32" bottom="0" top="0">
                          {departmentData?.result?.text[0]?.text_5}
                        </SubDetail>
                      )}

                      {departmentData?.result?.text[0]?.text_6 && (
                        <SubDetail indent="32" bottom="0" top="0">
                          {departmentData?.result?.text[0]?.text_6}
                        </SubDetail>
                      )}

                      <SubDetail className="bg-circle">
                        <img
                          loading="lazy"
                          src={learnIcon2}
                          alt="icon circle"
                        />
                        {departmentData?.result?.text[0]?.text_7}
                      </SubDetail>
                    </Col>
                  </Row>
                </FixBox>
              </Element>
            )}

            {departmentData?.teacher && (
              <Element name={departmentData?.teacher?.title}>
                <FixBox bg={ListColor2[slang]}>
                  <Row gutter={24} className="row-group">
                    <Col span={11}>
                      {departmentData?.teacher?.image ? (
                        departmentData?.teacher?.image.map((item) => {
                          return (
                            <FadeInSection axis="y">
                              <CustomCarousel autoplay bg={ListColor1[slang]}>
                                {item?.image_0 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_0}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                                {item?.image_1 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_1}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                                {item?.image_2 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_2}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                              </CustomCarousel>
                            </FadeInSection>
                          );
                        })
                      ) : (
                        <img
                          loading="lazy"
                          src={engineer1}
                          alt="icon group"
                          style={{ borderRadius: "20px", width: "100%" }}
                        />
                      )}
                    </Col>
                    <Col span={12} offset={1}>
                      <SubTitle>{departmentData?.teacher?.title}</SubTitle>
                      {departmentData?.teacher?.text.map((item) => {
                        return (
                          <>
                            {item?.text_0 && (
                              <SubDetail bottom="0" indent="32">
                                {item?.text_0}
                              </SubDetail>
                            )}
                            {item?.text_1 && (
                              <SubDetail top="0" bottom="0" indent="32">
                                {item?.text_1}
                              </SubDetail>
                            )}
                            {item?.text_2 && (
                              <SubDetail top="0" bottom="0" indent="32">
                                {item?.text_2}
                              </SubDetail>
                            )}
                            {item?.text_3 && (
                              <SubDetail top="0" indent="32">
                                {item?.text_3}
                              </SubDetail>
                            )}

                            {item?.text_4 && <SubHead>{item?.text_4}</SubHead>}
                            {item?.text_5 && (
                              <SubDetail top="0" bottom="0" indent="32">
                                {spliteLink(
                                  item?.text_5,
                                  "1) à¸•à¸£à¸§à¸ˆà¸ªà¸­à¸šà¸•à¸²à¸£à¸²à¸‡à¸ªà¸­à¸™à¸‚à¸­à¸‡à¸­à¸²à¸ˆà¸²à¸£à¸¢à¹Œà¸—à¸µà¹ˆà¸›à¸£à¸¶à¸à¸©à¸² à¸œà¹ˆà¸²à¸™à¸£à¸°à¸šà¸š "
                                )}
                              </SubDetail>
                            )}
                            {item?.text_6 && (
                              <SubDetail top="0" bottom="0" indent="32">
                                {spliteLink(
                                  item?.text_6,
                                  "2) à¸„à¹‰à¸™à¸«à¸²à¹€à¸šà¸­à¸£à¹Œà¹‚à¸—à¸£à¸¨à¸±à¸žà¸—à¹Œ E-mail à¸‚à¸­à¸‡à¸­à¸²à¸ˆà¸²à¸£à¸¢à¹Œ à¸«à¸£à¸·à¸­à¸ªà¸²à¸‚à¸²à¸§à¸´à¸Šà¸²à¸—à¸µà¹ˆà¸­à¸²à¸ˆà¸²à¸£à¸¢à¹Œà¸ªà¸±à¸‡à¸à¸±à¸” à¹„à¸”à¹‰à¸—à¸µà¹ˆ"
                                )}
                              </SubDetail>
                            )}
                            {item?.text_7 && (
                              <SubDetail top="0" bottom="0" indent="32">
                                {item?.text_7}
                              </SubDetail>
                            )}
                            {item?.text_8 && (
                              <SubDetail top="0" indent="32">
                                {spliteLinkEng(item?.text_8, "à¸”à¸¹à¸•à¹ˆà¸­ ")}
                              </SubDetail>
                            )}
                          </>
                        );
                      })}
                    </Col>
                  </Row>
                </FixBox>
              </Element>
            )}

            {departmentData?.estimate && (
              <Element name={departmentData?.estimate?.title}>
                <Row gutter={24} className="row-group">
                  <Col span={12}>
                    <SubTitle>{departmentData?.estimate?.title}</SubTitle>
                    <SubDetail bottom={"32"}>
                      {departmentData?.estimate?.text[0].text_0}
                    </SubDetail>

                    {departmentData?.estimate?.text[0].text_1 && (
                      <SubHead>
                        {departmentData?.estimate?.text[0].text_1}
                      </SubHead>
                    )}

                    {departmentData?.estimate?.text[0].text_2 && (
                      <SubDetail bottom={"0"} top="0" indent="32">
                        {spliteLink(
                          departmentData?.estimate?.text[0].text_2,
                          "1) Log in : "
                        )}
                      </SubDetail>
                    )}

                    {departmentData?.estimate?.text[0].text_3 && (
                      <SubDetail bottom="0" top="0" indent="32">
                        {departmentData?.estimate?.text[0].text_3}
                      </SubDetail>
                    )}

                    {departmentData?.estimate?.text[0].text_4 && (
                      <SubDetail bottom="0" top="0" indent="32">
                        {departmentData?.estimate?.text[0].text_4}
                      </SubDetail>
                    )}
                    {departmentData?.estimate?.text[0].text_5 && (
                      <SubDetail bottom="0" top="0" indent="32">
                        {departmentData?.estimate?.text[0].text_5}
                      </SubDetail>
                    )}
                    {departmentData?.estimate?.text[0].text_6 && (
                      <SubDetail bottom="0" top="0" indent="32">
                        {departmentData?.estimate?.text[0].text_6}
                      </SubDetail>
                    )}
                    {departmentData?.estimate?.text[0].text_7 && (
                      <SubDetail top="0" indent="32">
                        {departmentData?.estimate?.text[0].text_7}
                      </SubDetail>
                    )}
                  </Col>
                  <Col
                    span={11}
                    offset={1}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <FadeInSection axis="y">
                      <img
                        loading="lazy"
                        src={
                          departmentData?.estimate?.image &&
                          departmentData?.estimate?.image[0]?.image_0
                            ? departmentData?.estimate?.image[0]?.image_0
                            : engineer1
                        }
                        alt="icon rectangle"
                        style={{ borderRadius: "20px", width: "100%" }}
                      />
                    </FadeInSection>
                  </Col>
                </Row>
              </Element>
            )}

            {departmentData?.activity && (
              <Element name={departmentData?.activity?.title}>
                <FixBox bg={ListColor2[slang]}>
                  <Row gutter={24} className="row-group">
                    <Col span={11}>
                      {departmentData?.activity?.image ? (
                        departmentData?.activity?.image.map((item) => {
                          return (
                            <FadeInSection axis="x">
                              <CustomCarousel autoplay bg={ListColor1[slang]}>
                                {item?.image_0 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_0}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                                {item?.image_1 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_1}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                                {item?.image_2 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_2}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                                {item?.image_3 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_3}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                              </CustomCarousel>
                            </FadeInSection>
                          );
                        })
                      ) : (
                        <img
                          loading="lazy"
                          src={engineer1}
                          alt="icon group"
                          style={{ borderRadius: "20px", width: "100%" }}
                        />
                      )}
                    </Col>
                    <Col span={12} offset={1}>
                      <SubTitle>{departmentData?.activity?.title}</SubTitle>
                      {departmentData?.activity?.text.map((item) => {
                        return (
                          <>
                            {item?.text_0 && (
                              <SubDetail bottom="0">{item?.text_0}</SubDetail>
                            )}
                            {item?.text_1 && (
                              <SubDetail top="0" bottom="0" indent={"32"}>
                                {item?.text_1}
                              </SubDetail>
                            )}
                            {item?.text_2 && (
                              <SubDetail top="0" bottom="0" indent={"32"}>
                                {item?.text_2}
                              </SubDetail>
                            )}
                            {item?.text_3 && (
                              <SubDetail top="0" bottom={"0"} indent={"32"}>
                                {item?.text_3}
                              </SubDetail>
                            )}
                            {item?.text_4 && (
                              <SubDetail top="0" bottom="0" indent="32">
                                {item?.text_4}
                              </SubDetail>
                            )}
                            {item?.text_5 && (
                              <SubDetail top="0" bottom="0" indent={"32"}>
                                {item?.text_5}
                              </SubDetail>
                            )}
                            {item?.text_6 && (
                              <SubDetail top="0" bottom="0" indent={"32"}>
                                {item?.text_6}
                              </SubDetail>
                            )}
                            {item?.text_7 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_7}
                              </SubDetail>
                            )}
                            {item?.text_8 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_8}
                              </SubDetail>
                            )}
                            {item?.text_9 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_9}
                              </SubDetail>
                            )}
                            {item?.text_10 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_10}
                              </SubDetail>
                            )}
                            {item?.text_11 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_11}
                              </SubDetail>
                            )}
                            {item?.text_12 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_12}
                              </SubDetail>
                            )}
                            {item?.text_13 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_13}
                              </SubDetail>
                            )}
                            {item?.text_14 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_14}
                              </SubDetail>
                            )}
                            {item?.text_15 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_15}
                              </SubDetail>
                            )}
                          </>
                        );
                      })}
                    </Col>
                  </Row>
                </FixBox>
              </Element>
            )}

            {departmentData?.project && (
              <Element name={departmentData?.project?.title}>
                <Row gutter={24} className="row-group">
                  <Col span={12}>
                    <SubTitle>{departmentData?.project?.title}</SubTitle>
                    <SubDetail>
                      {departmentData?.project?.text[0]?.text_0}
                    </SubDetail>
                    <SubHead>
                      <a
                        href="https://beta.sut.ac.th/dsa/à¸‡à¸²à¸™à¸à¸´à¸ˆà¸à¸£à¸£à¸¡à¸™à¸±à¸à¸¨à¸¶à¸à¸©à¸²/à¹à¸šà¸šà¸Ÿà¸­à¸£à¹Œà¸¡à¸‡à¸²à¸™à¸à¸´à¸ˆà¸à¸£à¸£à¸¡à¸™à¸±à¸à¸¨"
                        target="_blank"
                        rel="noreferrer"
                        download
                      >
                        <img
                          src={downloadIcon}
                          alt="icon download file"
                          loading="lazy"
                        />
                        à¸”à¸²à¸§à¸™à¹Œà¹‚à¸«à¸¥à¸”à¹à¸šà¸šà¸Ÿà¸­à¸£à¹Œà¸¡
                      </a>
                    </SubHead>
                    {departmentData?.project?.text[0]?.text_1 && (
                      <SubDetail indent="32">
                        {departmentData?.project?.text[0]?.text_1}
                      </SubDetail>
                    )}
                    {departmentData?.project?.text[0]?.text_2 && (
                      <SubDetail indent="32">
                        {departmentData?.project?.text[0]?.text_2}
                      </SubDetail>
                    )}
                    {departmentData?.project?.text[0]?.text_3 && (
                      <TextNote>
                        {departmentData?.project?.text[0]?.text_3}
                      </TextNote>
                    )}
                  </Col>
                  <Col
                    span={11}
                    offset={1}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {departmentData.project?.image &&
                    departmentData.project.image[0]?.image_0 &&
                    !departmentData.project.image[0]?.image_1 ? (
                      <FadeInSection axis="y">
                        <img
                          loading="lazy"
                          src={departmentData.project.image[0]?.image_0}
                          alt="icon group"
                          style={{
                            borderRadius: "20px",
                            width: "100%",
                          }}
                        />
                      </FadeInSection>
                    ) : (
                      departmentData.project.image.map((item) => {
                        return (
                          <CustomCarousel autoplay bg={ListColor1[slang]}>
                            {item.image_0 && (
                              <img
                                loading="lazy"
                                src={item.image_0}
                                alt="icon group"
                                style={{
                                  borderRadius: "20px",
                                  width: "100%",
                                }}
                              />
                            )}
                            {item.image_1 && (
                              <img
                                loading="lazy"
                                src={item.image_1}
                                alt="icon group"
                                style={{
                                  borderRadius: "20px",
                                  width: "100%",
                                }}
                              />
                            )}
                            {item.image_2 && (
                              <img
                                loading="lazy"
                                src={item.image_2}
                                alt="icon group"
                                style={{
                                  borderRadius: "20px",
                                  width: "100%",
                                }}
                              />
                            )}
                          </CustomCarousel>
                        );
                      })
                    )}
                  </Col>
                </Row>
              </Element>
            )}

            {departmentData?.project_show && (
              <Element name={departmentData?.project_show?.title}>
                <FixBox bg={ListColor2[slang]}>
                  <Row gutter={24} className="row-group">
                    <Col span={11}>
                      {departmentData?.project_show?.image ? (
                        departmentData?.project_show?.image.map((item) => {
                          return (
                            <FadeInSection axis="x">
                              <CustomCarousel autoplay bg={ListColor1[slang]}>
                                {item?.image_0 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_0}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                                {item?.image_1 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_1}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                                {item?.image_2 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_2}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                              </CustomCarousel>
                            </FadeInSection>
                          );
                        })
                      ) : (
                        <img
                          loading="lazy"
                          src={engineer1}
                          alt="icon group"
                          style={{ borderRadius: "20px", width: "100%" }}
                        />
                      )}
                    </Col>
                    <Col span={12} offset={1}>
                      <SubTitle>{departmentData?.project_show?.title}</SubTitle>
                      {departmentData?.project_show?.text.map((item) => {
                        return (
                          <>
                            {item?.text_0 && (
                              <SubDetail indent="32">{item?.text_0}</SubDetail>
                            )}
                            {item?.text_1 && (
                              <SubDetail top="0" bottom="0" indent="32">
                                {item?.text_1}
                              </SubDetail>
                            )}
                            {item?.text_2 && (
                              <SubDetail top="0" bottom="0">
                                {spliteLinkProject(
                                  item?.text_2,
                                  "Download ",
                                  "https://web.sut.ac.th/dbg/dbg_form.html"
                                )}
                              </SubDetail>
                            )}
                            {item?.text_3 && (
                              <SubDetail bottom="0" indent="32">
                                {item?.text_3}
                              </SubDetail>
                            )}
                            {item?.text_4 && (
                              <TextNote top="0">{item?.text_4}</TextNote>
                            )}
                          </>
                        );
                      })}
                    </Col>
                  </Row>
                </FixBox>
              </Element>
            )}

            {departmentData?.q1 && (
              <Element name={departmentData?.q1?.title}>
                <SubTitle top="50" bottom="0" align="center">
                  {departmentData?.q1?.title}
                </SubTitle>

                <NameCourse align="center" top="0" bottom="35">
                  {departmentData?.q1?.text[0]?.text_0}
                </NameCourse>

                {departmentData?.q1?.text && departmentData?.q1?.text[0] && (
                  <>
                    <Row className="row-col-3">
                      <Col span={8}>
                        <Box>
                          <NumberList>
                            <NumberImage number={1} position={0} />
                          </NumberList>
                          <NameCourse bottom="4">
                            à¸à¸£à¸­à¸à¹à¸šà¸šà¸Ÿà¸­à¸£à¹Œà¸¡à¸‚à¸­à¸ªà¸¥à¸°à¸ªà¸´à¸—à¸˜à¸´à¹Œ
                          </NameCourse>

                          <a
                            href={
                              "https://beta.sut.ac.th/ie/%e0%b8%9b%e0%b8%a3%e0%b8%b4%e0%b8%8d%e0%b8%8d%e0%b8%b2%e0%b8%95%e0%b8%a3%e0%b8%b5-2"
                            }
                            target="_blank"
                            rel="noreferrer"
                            download
                          >
                            <img
                              loading="lazy"
                              src={downloadIcon}
                              alt="icon download file"
                              style={{ height: "32px", marginRight: "12px" }}
                            />
                            <span>à¸”à¸²à¸§à¸™à¹Œà¹‚à¸«à¸¥à¸”à¹à¸šà¸šà¸Ÿà¸­à¸£à¹Œà¸¡</span>
                          </a>
                        </Box>
                      </Col>
                      <Col span={8}>
                        <Box>
                          <NumberList>
                            <NumberImage number={2} position={45} />
                          </NumberList>
                          <NameCourse bottom="4">
                            à¸™à¹à¸²à¹à¸šà¸šà¸Ÿà¸­à¸£à¹Œà¸¡ à¹€à¸‚à¹‰à¸²à¸žà¸šà¹à¸¥à¸°à¸‚à¸­à¸­à¸™à¸¸à¸¡à¸±à¸•à¸´ à¸•à¸²à¸¡à¸¥à¹à¸²à¸”à¸±à¸š
                          </NameCourse>
                          <SubDetail left="5" top="0" bottom="0">
                            {"à¸­à¸²à¸ˆà¸²à¸£à¸¢à¹Œà¸—à¸µà¹ˆà¸›à¸£à¸¶à¸à¸©à¸² >"}
                          </SubDetail>
                          <SubDetail left="5" top="0" bottom="0">
                            {" à¸«à¸±à¸§à¸«à¸™à¹‰à¸²à¸ªà¸²à¸‚à¸² >"}
                          </SubDetail>
                          <SubDetail left="5" top="0">
                            à¸™à¸³à¹à¸šà¸šà¸Ÿà¸­à¸£à¹Œà¸¡à¸ªà¹ˆà¸‡à¸—à¸µà¹ˆà¸ªà¸³à¸™à¸±à¸à¸§à¸´à¸Šà¸²à¸§à¸´à¸¨à¸§à¸à¸£à¸£à¸¡à¸¨à¸²à¸ªà¸•à¸£à¹Œ
                          </SubDetail>
                        </Box>
                      </Col>

                      <Col span={8}>
                        <Box>
                          <NumberList>
                            <NumberImage number={3} position={90} />
                          </NumberList>
                          <NameCourse bottom="4">
                            à¸•à¸£à¸§à¸ˆà¸ªà¸­à¸šà¸£à¸²à¸¢à¸Šà¸·à¹ˆà¸­à¹„à¸”à¹‰ 2 à¸—à¸²à¸‡
                          </NameCourse>

                          <div className="link-web eng">
                            <a
                              href={`https://beta.sut.ac.th/ie/%e0%b8%9b%e0%b8%a3%e0%b8%b4%e0%b8%8d%e0%b8%8d%e0%b8%b2%e0%b8%95%e0%b8%a3%e0%b8%b5-2`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              1) <u> à¹€à¸§à¹‡à¸šà¹„à¸‹à¸•à¹Œà¸¨à¸¹à¸™à¸¢à¹Œà¸šà¸£à¸´à¸à¸²à¸£à¸à¸²à¸£à¸¨à¸¶à¸à¸©à¸² CES</u>
                            </a>
                          </div>
                          <div className="link-web eng">
                            <a
                              href={`https://eng.sut.ac.th/`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              2) <u> à¹€à¸§à¹‡à¸šà¹„à¸‹à¸•à¹Œà¸ªà¸³à¸™à¸±à¸à¸§à¸´à¸Šà¸²à¸§à¸´à¸¨à¸§à¸à¸£à¸£à¸¡à¸¨à¸²à¸ªà¸•à¸£à¹Œ</u>
                            </a>
                          </div>
                        </Box>
                      </Col>
                    </Row>

                    <ListImage
                      noteText="Note: à¸ªà¸²à¸¡à¸²à¸£à¸–à¸ªà¸¥à¸°à¸ªà¸´à¸—à¸˜à¸´à¹Œà¹„à¸”à¹‰à¹ƒà¸™à¹€à¸—à¸­à¸¡ 3 à¸à¹ˆà¸­à¸™à¹€à¸¥à¸·à¸­à¸à¸ªà¸²à¸‚à¸² à¸›à¸£à¸°à¸¡à¸²à¸“ 1 à¸ªà¸±à¸›à¸”à¸²à¸«à¹Œà¹Œà¹€à¸—à¹ˆà¸²à¸™à¸±à¹‰à¸™ à¸–à¹‰à¸²à¹„à¸”à¹‰à¸£à¸±à¸šà¸­à¸™à¸¸à¸¡à¸±à¸•à¸´à¹ƒà¸«à¹‰à¸ªà¸¥à¸°à¸ªà¸´à¸—à¸˜à¸´à¹Œà¹à¸¥à¹‰à¸§ à¸ˆà¸°à¹€à¸¥à¸·à¸­à¸à¸ªà¸²à¸‚à¸²à¸§à¸´à¸Šà¸²à¸¯ à¹ƒà¸«à¸¡à¹ˆà¹„à¸”à¹‰à¸•à¸²à¸¡à¸›à¸à¸•à¸´"
                      type="note"
                      font="Noto Sans Thai"
                    />
                  </>
                )}
              </Element>
            )}

            {departmentData?.table_grad && (
              <Element name={departmentData?.table_grad?.title}>
                <FixBox bg={ListColor2[slang]}>
                  <SubTitle top="50" align="center">
                    {departmentData?.table_grad?.title}
                  </SubTitle>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <TableGPAX col={4} data4={gradeData} />
                  </div>
                  <div style={{ width: "100%", display: "flex" }}>
                    <Line />
                  </div>
                  <Detail color="#81000F">
                    <a
                      href="http://bulletin.sut.ac.th/enrollment/calculate-grade"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        loading="lazy"
                        src={handRightIcon}
                        alt="icon download file"
                        style={{ margin: "0 20px", height: "32px" }}
                      />
                      <span style={{ fontWeight: "600" }}>
                        à¸”à¸¹à¸•à¸±à¸§à¸­à¸¢à¹ˆà¸²à¸‡à¸à¸²à¸£à¸„à¸³à¸™à¸§à¸“ grade point
                      </span>
                    </a>
                  </Detail>

                  <ListImage
                    noteText="Warning: 1) à¸«à¸²à¸à¸­à¸¢à¸²à¸à¹„à¸”à¹‰à¸ªà¸²à¸‚à¸²à¸—à¸µà¹ˆà¸–à¸¹à¸à¹ƒà¸ˆ à¸•à¹‰à¸­à¸‡à¸—à¹à¸² Grade Point à¹ƒà¸«à¹‰à¸ªà¸¹à¸‡à¹€à¸‚à¹‰à¸²à¹„à¸§à¹‰ 2) à¸­à¸²à¸ˆà¸¡à¸µà¸à¸²à¸£à¸ªà¸¥à¸±à¸šà¹€à¸—à¸­à¸¡à¸‚à¸­à¸‡à¸à¸¥à¸¸à¹ˆà¸¡à¸à¸²à¸£à¸¥à¸‡à¸—à¸°à¹€à¸šà¸µà¸¢à¸™ à¸•à¸²à¸¡à¸à¸¥à¸¸à¹ˆà¸¡à¸™à¸±à¸à¸¨à¸¶à¸à¸©à¸²"
                    type="note"
                    font="Noto Sans Thai"
                  />
                </FixBox>
              </Element>
            )}

            {departmentData?.select_subject && (
              <Element name={departmentData?.select_subject?.title}>
                <SubTitle>{departmentData?.select_subject?.title}</SubTitle>
                <Row gutter={[24, 24]} className="row-system">
                  <Col span={12}>
                    <FadeInSection axis="y">
                      <img
                        loading="lazy"
                        src={
                          departmentData?.select_subject?.image &&
                          departmentData?.select_subject?.image[0]?.image_0
                        }
                        alt="register credits"
                        style={styleImage}
                      />
                    </FadeInSection>
                    {departmentData?.select_subject?.text && (
                      <>
                        <TextHead>
                          1) {departmentData?.select_subject?.text[0]?.text_0}
                        </TextHead>
                        <Detail align="left" bottom="0">
                          {departmentData?.select_subject?.text[0]?.text_1}
                        </Detail>
                        <Detail align="left" top="0">
                          {departmentData?.select_subject?.text[0]?.text_2}
                        </Detail>
                      </>
                    )}
                  </Col>
                  <Col span={12}>
                    <FadeInSection axis="y">
                      <img
                        loading="lazy"
                        src={
                          departmentData?.select_subject?.image &&
                          departmentData?.select_subject?.image[0]?.image_1
                        }
                        alt="register credits"
                        style={styleImage}
                      />
                    </FadeInSection>
                    {departmentData?.select_subject?.text && (
                      <>
                        <TextHead>
                          2) {departmentData?.select_subject?.text[0]?.text_3}
                        </TextHead>
                        <Detail align="left">
                          {departmentData?.select_subject?.text[0]?.text_4}
                        </Detail>
                      </>
                    )}
                  </Col>
                </Row>

                {departmentData?.select_subject?.text && (
                  <>
                    <TitleSelect>
                      {departmentData?.select_subject?.text[0]?.text_5}
                    </TitleSelect>

                    <Detail>
                      {departmentData?.select_subject?.text[0]?.text_6}
                    </Detail>
                    <div style={{ width: "90%" }}>
                      <Line />
                    </div>
                    <TitleSelect>
                      {departmentData?.select_subject?.text[0]?.text_7}
                    </TitleSelect>
                    <Detail>
                      {departmentData?.select_subject?.text[0]?.text_8}
                    </Detail>
                  </>
                )}

                <Detail>
                  <a
                    href="http://web.sut.ac.th/ces/2018/ces/formST/05.pdf"
                    target="_blank"
                    rel="noreferrer"
                    download
                  >
                    <img
                      loading="lazy"
                      src={downloadIcon}
                      alt="icon download file"
                      style={{ margin: "0 20px", height: "32px" }}
                    />
                    <span>à¸”à¸²à¸§à¸™à¹Œà¹‚à¸«à¸¥à¸”à¹à¸šà¸šà¸Ÿà¸­à¸£à¹Œà¸¡</span>
                  </a>
                </Detail>

                {departmentData?.select_subject?.text && (
                  <ListImage
                    noteText={departmentData?.select_subject?.text[0]?.text_10}
                    type="note"
                    font="Noto Sans Thai"
                  />
                )}
              </Element>
            )}

            {departmentData?.registered_GPAX && (
              <Element name={departmentData?.registered_GPAX?.title}>
                <FixBox bg="#FBFBFB">
                  <Row gutter={[24, 24]} className="row-contact">
                    <Col span={8}>
                      <FadeInSection axis="x">
                        <img
                          loading="lazy"
                          src={engGPAX}
                          alt="registered GPAX"
                          style={styleImage}
                        />
                      </FadeInSection>
                    </Col>
                    <Col span={15} offset={1} className="col-leave">
                      <SubTitle>
                        {departmentData?.registered_GPAX?.title}
                      </SubTitle>
                      {departmentData?.registered_GPAX?.text &&
                        departmentData?.registered_GPAX?.text.map((item) => {
                          return (
                            <>
                              {item?.text_0 && (
                                <NumberList>
                                  <NumberImage number={1} position={0} />
                                  <div>
                                    Download à¹ƒà¸šà¸¢à¸·à¸™à¸¢à¸±à¸™à¸à¸²à¸£à¸žà¸šà¸­à¸²à¸ˆà¸²à¸£à¸¢à¹Œà¸—à¸µà¹ˆà¸›à¸£à¸¶à¸à¸©à¸² à¹„à¸”à¹‰ 2
                                    à¸Šà¹ˆà¸­à¸‡à¸—à¸²à¸‡
                                    <div className="link-web eng">
                                      <a
                                        href={
                                          "https://reg3.sut.ac.th/registrar/Form/FormAdvisors.asp"
                                        }
                                        target="_blank"
                                        rel="noreferrer"
                                      >
                                        1){" "}
                                        <u>
                                          à¹€à¸§à¹‡à¸šà¹„à¸‹à¸•à¹Œ Download
                                          à¹ƒà¸šà¸¢à¸·à¸™à¸¢à¸±à¸™à¸à¸²à¸£à¸žà¸šà¸­à¸²à¸ˆà¸²à¸£à¸¢à¹Œà¸—à¸µà¹ˆà¸›à¸£à¸¶à¸à¸©à¸²
                                        </u>
                                      </a>
                                    </div>
                                    <div className="link-web eng">
                                      <a
                                        href={
                                          "http://sutgateway.sut.ac.th/ces/%E0%B8%99%E0%B8%B1%E0%B8%81%E0%B8%A8%E0%B8%B6%E0%B8%81%E0%B8%A9%E0%B8%B2/download-%E0%B8%84%E0%B8%B3%E0%B8%A3%E0%B8%AD%E0%B8%87/"
                                        }
                                        target="_blank"
                                        rel="noreferrer"
                                      >
                                        2){" "}
                                        <u>
                                          à¹à¸šà¸šà¸Ÿà¸­à¸£à¹Œà¸¡à¸„à¸³à¸£à¹‰à¸­à¸‡à¸ªà¸³à¸«à¸£à¸±à¸š à¸™à¸¨.à¸—à¸µà¹ˆ GPAX
                                          à¸•à¹ˆà¸³à¸à¸§à¹ˆà¸² 2.00 à¹‚à¸”à¸¢à¸¨à¸¹à¸™à¸¢à¹Œà¸šà¸£à¸´à¸à¸²à¸£à¸à¸²à¸£à¸¨à¸¶à¸à¸©à¸²
                                          CES
                                        </u>
                                      </a>
                                    </div>
                                  </div>
                                </NumberList>
                              )}
                              {item?.text_1 && (
                                <NumberList>
                                  <NumberImage number={2} position={45} />
                                  à¸à¸£à¸­à¸à¸‚à¹‰à¸­à¸¡à¸¹à¸¥
                                </NumberList>
                              )}

                              {item?.text_2 && (
                                <NumberList>
                                  <NumberImage number={3} position={90} />
                                  à¸ªà¹ˆà¸‡à¹€à¸­à¸à¸ªà¸²à¸£à¸•à¸²à¸¡à¸—à¸µà¹ˆà¸£à¸°à¸šà¸šà¸à¸³à¸«à¸™à¸”
                                </NumberList>
                              )}
                              {item?.text_3 && (
                                <NumberList>
                                  <NumberImage number={4} position={180} />
                                  à¸žà¸šà¸­à¸²à¸ˆà¸²à¸£à¸¢à¹Œà¸—à¸µà¹ˆà¸›à¸£à¸¶à¸à¸©à¸²à¹à¸šà¸šà¸­à¸­à¸™à¹„à¸¥à¸™à¹Œ
                                  à¸«à¸£à¸·à¸­à¸•à¸²à¸¡à¸—à¸µà¹ˆà¸­à¸²à¸ˆà¸²à¸£à¸¢à¹Œà¸—à¸µà¹ˆà¸›à¸£à¸¶à¸à¸©à¸²à¸à¸³à¸«à¸™à¸”
                                </NumberList>
                              )}

                              {item?.text_4 && (
                                <ListImage
                                  noteText="Note: à¸«à¸²à¸à¸¡à¸µà¸›à¸±à¸à¸«à¸²à¹€à¸£à¸·à¹ˆà¸­à¸‡à¸”à¸²à¸§à¸™à¹Œà¹‚à¸«à¸¥à¸”à¹à¸šà¸šà¸Ÿà¸­à¸£à¹Œà¸¡à¹„à¸¡à¹ˆà¹„à¸”à¹‰ à¸•à¸´à¸”à¸•à¹ˆà¸­à¸à¹ˆà¸²à¸¢à¸§à¸´à¹€à¸„à¸£à¸²à¸°à¸«à¹Œà¹à¸¥à¸°à¸žà¸±à¸’à¸™à¸²à¸£à¸°à¸šà¸š à¹‚à¸—à¸£. 0-4422-4223"
                                  type="note"
                                  font="Noto Sans Thai"
                                />
                              )}
                            </>
                          );
                        })}
                    </Col>
                  </Row>
                </FixBox>
              </Element>
            )}

            {contactData && (
              <>
                <SubTitle top="60" align="center">
                  {ListContact[slang]}
                </SubTitle>
                <Row
                  gutter={24}
                  style={{ marginTop: "50px" }}
                  className="row-contact"
                >
                  <Col span={8}>
                    <CardContact background={ListColorContact[slang]}>
                      <div className="container">
                        <DetailContact
                          color={`${"white"}`}
                          title={contactData[0]?.title}
                          phone={contactData[0]?.phone_1}
                          office={contactData[0]?.phone_2}
                          facebook={contactData[0]?.fb}
                          website={contactData[0]?.site}
                          email1={contactData[0]?.email_1}
                          email2={contactData[0]?.email_2}
                          email3={contactData[0]?.email_3}
                          line={contactData[0]?.line}
                          indent="40"
                          type="department"
                        />
                      </div>

                      {contactData && (
                        <img
                          loading="lazy"
                          src={
                            contactData[0]?.image
                              ? contactData[0]?.image
                              : listImageContact[slang]
                          }
                          alt="icon rectangle"
                          style={{
                            borderRadius: "20px",
                            width: "100%",
                            marginTop: "20px",
                          }}
                        />
                      )}
                    </CardContact>
                  </Col>

                  <Col span={15} offset={1}>
                    <Row gutter={24}>
                      {contactData.length > 1
                        ? contactData.slice(1).map((item, index) => {
                            return (
                              <Col
                                span={12}
                                style={{ padding: "10px" }}
                                key={index}
                              >
                                <div style={styleDetailContact}>
                                  <DetailContact
                                    color="var(--black)"
                                    title={item?.title}
                                    phone={item?.phone_1}
                                    office={item?.phone_2}
                                    facebook={item?.fb}
                                    website={item?.site}
                                    email1={item?.email_1}
                                    email2={item?.email_2}
                                    email3={item?.email_3}
                                    line={item?.line}
                                    indent={"40"}
                                    slang={slang}
                                    type="branch"
                                  />
                                </div>
                              </Col>
                            );
                          })
                        : contactData[0]?.address !== "" && (
                            <Col span={12} style={{ padding: "10px" }}>
                              <DetailContact
                                color="var(--black)"
                                title={contactData[0]?.title}
                                address={contactData[0]?.address}
                                slang={slang}
                                type="branch"
                              />
                            </Col>
                          )}
                    </Row>
                  </Col>
                </Row>
              </>
            )}
            <FixBoxLayout bg={ListColor2[slang]}>
              <div className="layout-view">
                <Row className="row-group" style={{ alignItems: "center" }}>
                  <Col span={6}>
                    <img
                      loading="lazy"
                      src={stuView}
                      style={{ width: "100%", maxWidth: "460px" }}
                      alt="student view"
                    />
                  </Col>
                  <Col offset={1} span={17}>
                    <div style={{ maxwWidth: "450px" }}>
                      <SubHead weight="bold">{ListView[slang]}</SubHead>
                      <Row className="row-view">
                        <Col span={12}>
                          <SubHead>à¸•à¸±à¹‰à¸‡à¹à¸•à¹ˆà¹€à¸£à¸´à¹ˆà¸¡à¹€à¸›à¸´à¸”à¹€à¸§à¹‡à¸šà¹„à¸‹à¸•à¹Œ</SubHead>
                          <View>
                            <CountUp
                              start={0}
                              end={view.viewAll ? view?.viewAll : 0}
                              duration={2}
                              useEasing={true}
                              useGrouping={true}
                              separator=","
                              decimals={0}
                              decimal=","
                            />
                          </View>
                          <SubHead>à¸„à¸£à¸±à¹‰à¸‡</SubHead>
                        </Col>
                        <Col span={12}>
                          <div
                            style={{
                              display: "flex",
                              gap: "20px",
                            }}
                          >
                            <SubHead>à¸›à¸µ (à¸ž.à¸¨.)</SubHead>
                            <ViewSelect
                              year={year}
                              background="#EA8B49"
                              onChange={(value) => getView(value)}
                            />
                          </div>
                          <View>
                            <CountUp
                              start={0}
                              end={view?.viewOfYear ? view?.viewOfYear : 0}
                              duration={2}
                              useEasing={true}
                              useGrouping={true}
                              separator=","
                              decimals={0}
                              decimal=","
                            />
                          </View>
                          <SubHead>à¸„à¸£à¸±à¹‰à¸‡</SubHead>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </FixBoxLayout>
          </>
        ) : (
          <LoadingSpin />
        )}
      </Container>
      <ScrollUpBtn />
    </>
  );
}

export default EngineeringDepartment;
